"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminOnboardingTaskStatus = exports.AdminOnboardingTaskLabel = void 0;
var AdminOnboardingTaskLabel;
(function (AdminOnboardingTaskLabel) {
    AdminOnboardingTaskLabel["InvitationSent"] = "invitation_sent";
    AdminOnboardingTaskLabel["DomainProvided"] = "domain_provided";
    AdminOnboardingTaskLabel["TagImplemented"] = "tag_implemented";
    AdminOnboardingTaskLabel["TimezoneProvided"] = "timezone_provided";
    AdminOnboardingTaskLabel["CurrencyProvided"] = "currency_provided";
    AdminOnboardingTaskLabel["ThemeDefined"] = "theme_defined";
})(AdminOnboardingTaskLabel = exports.AdminOnboardingTaskLabel || (exports.AdminOnboardingTaskLabel = {}));
var AdminOnboardingTaskStatus;
(function (AdminOnboardingTaskStatus) {
    AdminOnboardingTaskStatus["Pending"] = "pending";
    AdminOnboardingTaskStatus["Done"] = "done";
    AdminOnboardingTaskStatus["Error"] = "error";
})(AdminOnboardingTaskStatus = exports.AdminOnboardingTaskStatus || (exports.AdminOnboardingTaskStatus = {}));
//# sourceMappingURL=types.js.map